import { render } from "./Report.vue?vue&type=template&id=0da0bc5b&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import "./Report.vue?vue&type=style&index=0&id=0da0bc5b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da0bc5b"]])

export default __exports__